// extracted by mini-css-extract-plugin
module.exports = {"wrap":"WideBannerAd_wrap__fsFny","inner":"WideBannerAd_inner__rrZ8E","header":"WideBannerAd_header__M5FTd","label":"WideBannerAd_label__VrlEi"};